import { render } from "./vderpartnerdvclist.vue?vue&type=template&id=4121ac77&scoped=true"
import script from "./vderpartnerdvclist.vue?vue&type=script&lang=js"
export * from "./vderpartnerdvclist.vue?vue&type=script&lang=js"

import "./vderpartnerdvclist.vue?vue&type=style&index=0&id=4121ac77&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4121ac77"]])

export default __exports__